import React, { FC } from 'react'
import { useNavigate } from 'react-router-dom'

interface CustomBreadcrumbProps {
    items: Array<{ title: string, path?: string, isActive?: boolean }>
}

const CustomBreadcrumb: FC<CustomBreadcrumbProps> = ({ items }) => {
    const navigate = useNavigate()

    const handleClick = (path: string) => {
        window.history.go(-2)
        setTimeout(() => {
            navigate(path)
        }, 100)
    }

    return (
        <div className="d-flex align-items-center mb-3" style={{ marginTop: "4px" }}>
            {items.map((item, index) => (
                <span key={index}>
                    {item.path && !item.isActive ? (
                        <span
                            onClick={() => handleClick(item.path!)}
                            className="text-dark text-hover-primary cursor-pointer fs-7"
                            style={{ cursor: 'pointer' }}
                        >
                            {item.title}
                        </span>
                    ) : (
                        <span className={item.isActive ? 'text-gray-700 fs-7' : 'text-dark fs-7'}>
                            {item.title}
                        </span>
                    )}
                    {index < items.length - 1 && (
                        <span className="text-dark mx-2 fs-7" style={{ fontWeight: 'bold' }}>-</span>
                    )}
                </span>
            ))}
        </div>
    )
}
export { CustomBreadcrumb }